import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum EamPurchaseOrderPermissionSet {
  View = 'eam_purchase_order_view',
  Write = 'eam_purchase_order_write',
  Receive = 'eam_purchase_order_receive',
}

export const eamPurchaseOrderPermissionSetGrouping: IPermissionSetGrouping<EamPurchaseOrderPermissionSet> = {
  key: PermissionSetGroupingKey.EamPurchaseOrder,
  active: {
    [EamPurchaseOrderPermissionSet.View]: [PermissionType.GET_ANY_EAM_PURCHASE_ORDER],
    [EamPurchaseOrderPermissionSet.Write]: [PermissionType.WRITE_ANY_EAM_PURCHASE_ORDER],
    [EamPurchaseOrderPermissionSet.Receive]: [PermissionType.RECEIVE_ANY_EAM_PURCHASE_ORDER],
  },
  unAssignablePermissionSets: [],
}
